export const PAGE_HASHTAG_TYPE = {
  HORIZONTAL: 'horizontal',
  SPREAD: 'spread',
  VERTICAL: 'vertical',
  HIDDEN: 'hidden',
} as const;

export const PAGE_HASHTAG_MAP = {
  [PAGE_HASHTAG_TYPE.HORIZONTAL]: '가로형-스크롤',
  [PAGE_HASHTAG_TYPE.SPREAD]: '가로형-모두 펼치기',
  [PAGE_HASHTAG_TYPE.VERTICAL]: '세로형',
  [PAGE_HASHTAG_TYPE.HIDDEN]: '표시 안함',
};

export type PAGE_HASHTAG_TYPE_KEY = keyof typeof PAGE_HASHTAG_TYPE;
export type PAGE_HASHTAG_TYPE_VALUE =
  typeof PAGE_HASHTAG_TYPE[PAGE_HASHTAG_TYPE_KEY];

export const pageTagTypeList = Object.keys(PAGE_HASHTAG_MAP).map((key) => {
  return {
    key: key,
    value: PAGE_HASHTAG_MAP[key],
  };
});
